// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header {
  min-height: 84px;
  padding: 18px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background: white;
  border-bottom: 1px solid #e0e7e0;
}
.brand {
  font-size: 19px;
  font-weight: 700;
  color: #20332e;
  display: flex;
  gap: 12px;
  align-items: center;
}
.brand-icon {
  background: #285c46;
  color: white;
  padding: 8px;
  border-radius: 9px;
  font-family: monospace;
}
nav {
  display: flex;
  align-items: center;
  gap: 25px;
  font-size: 14px;
}
nav .active {
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 8px;
}
main {
  max-width: 1240px;
  margin: 0 auto;
  padding: 48px 32px;
  min-height: calc(100vh - 145px);
}
footer {
  padding: 20px;
  text-align: center;
  color: #687b70;
  font-size: 12px;
}
.eyebrow {
  color: #43755b;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 11px;
  font-weight: 700;
}
.muted {
  color: #64766c;
  line-height: 1.65;
}
.panel {
  background: white;
  border: 1px solid #dfe7df;
  border-radius: 14px;
  padding: 28px;
  margin-top: 30px;
}
.primary {
  background: #285c46;
  color: white;
  border-color: #285c46;
}
button.primary:hover:not(:disabled) {
  background: #1c4433;
}
.filters {
  display: flex;
  gap: 18px;
  border-bottom: 1px solid #e4eae4;
  padding-bottom: 24px;
}
.filters label {
  width: 230px;
}
.problem-row {
  display: flex;
  gap: 24px;
  align-items: center;
  padding: 22px 2px;
  border-bottom: 1px solid #e9eee9;
  color: inherit;
}
.problem-row:hover {
  background: #f8faf7;
  text-decoration: none;
}
.problem-row > div {
  flex: 1 1;
}
.problem-row h2 {
  margin: 0 0 8px;
}
.problem-row p {
  margin: 0;
  font-size: 13px;
}
.badge {
  display: inline-block;
  background: #edf0ed;
  color: #53645a;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
}
.difficulty-1 {
  color: #246342;
  background: #e9f4ec;
}
.difficulty-2 {
  color: #866014;
  background: #fcf3db;
}
.difficulty-3 {
  color: #a54843;
  background: #fbeceb;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 18px;
  margin-top: 24px;
  font-size: 13px;
}
.auth-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  max-width: 1040px;
  margin: 30px auto;
}
.auth-intro h1 {
  font-size: clamp(36px, 5vw, 58px);
  line-height: 1.13;
}
.auth-intro > p:last-child {
  color: #64766c;
  line-height: 1.8;
  max-width: 370px;
}
.auth-card form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 26px;
}
.auth-links {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 12px;
  margin-top: 26px;
}
.error {
  background: #fff0ed;
  color: #a23228;
  padding: 14px;
  border-radius: 8px;
  line-height: 1.5;
}
.success {
  background: #edf7ef;
  color: #23633d;
  padding: 16px;
  line-height: 1.6;
}
.page-heading {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 16px;
}
.workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 24px;
}
.workspace .panel {
  margin-top: 0;
}
.prose {
  white-space: pre-wrap;
  line-height: 1.8;
}
.code-block {
  background: #1c2521;
  color: #e7ede9;
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 13px;
  line-height: 1.6;
}
.progress-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 30px;
}
.progress-stat,
.progress-section {
  background: white;
  border: 1px solid #dfe7df;
  border-radius: 10px;
  padding: 22px;
}
.progress-stat strong {
  display: block;
  color: #285c46;
  font-size: 30px;
}
.progress-stat span,
.progress-row span,
.activity-list time {
  color: #64766c;
  font-size: 13px;
}
.progress-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 24px;
}
.progress-section h2 { margin-top: 0; }
.progress-row,
.activity-list li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e9eee9;
}
.activity-list { list-style: none; padding: 0; }
button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid #d18b28;
  outline-offset: 3px;
}
@media (max-width: 760px) {
  .site-header { align-items: flex-start; flex-direction: column; }
  nav { flex-wrap: wrap; gap: 14px; }
  main { padding: 32px 18px; }
  .workspace,
  .auth-layout,
  .progress-grid { grid-template-columns: 1fr; gap: 18px; }
  .progress-summary { grid-template-columns: 1fr; }
  .panel { padding: 20px; }
  .filters { flex-direction: column; }
  .filters label { width: auto; }
  .progress-row { align-items: flex-start; flex-wrap: wrap; }
  .progress-row span:last-child { margin-left: auto; }
  .table-scroll { max-width: 100%; overflow-x: auto; }
}
.tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 24px 0;
}
.editor {
  display: flex;
  flex-direction: column;
  padding: 0;
  overflow: hidden;
}
.editor-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 20px;
}
.editor-heading label {
  font-size: 12px;
}
.code-label {
  padding: 0 20px 10px;
}
.code-editor {
  width: 100%;
  flex: 1 1;
  min-height: 400px;
  resize: vertical;
  background: #1d2c26;
  color: #d9ecdf;
  border: none;
  padding: 24px;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 14px;
  line-height: 1.75;
  tab-size: 4;
}
.code-editor::placeholder {
  color: #a1b9ab;
}
.editor-footer {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  font-size: 12px;
}
.editor .error {
  margin: 12px;
}
.empty {
  padding: 45px 20px;
  text-align: center;
  color: #64766c;
}
.table-scroll {
  overflow-x: auto;
}
table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  font-size: 14px;
}
th {
  color: #687b70;
  font-size: 12px;
  font-weight: 500;
}
td,
th {
  padding: 18px 14px;
  border-bottom: 1px solid #e5ebe5;
}
.result-meta {
  display: flex;
  align-items: center;
  gap: 22px;
}
.result-meta button {
  margin-left: auto;
}
.submitted-code {
  background: #1d2c26;
  color: #d9ecdf;
}
@media (max-width: 760px) {
  main {
    padding: 28px 18px;
  }
  .site-header {
    flex-wrap: wrap;
    padding: 16px 18px;
  }
  nav {
    gap: 16px;
  }
  .auth-layout,
  .workspace {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .auth-layout {
    margin: 0;
  }
  .auth-intro h1 {
    font-size: 36px;
  }
  .panel {
    padding: 20px;
  }
  .editor {
    padding: 0;
  }
  .filters {
    flex-wrap: wrap;
  }
  .filters label {
    width: 100%;
  }
  .problem-row {
    gap: 12px;
  }
  .page-heading {
    flex-wrap: wrap;
    gap: 0 16px;
  }
  .editor-footer {
    flex-wrap: wrap;
  }
  .result-meta {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,SAAO;AACT;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sDAAsD;EACtD,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA,uBAAuB,aAAa,EAAE;AACtC;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;AACA,iBAAiB,gBAAgB,EAAE,UAAU,EAAE;AAC/C;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,eAAe,uBAAuB,EAAE,sBAAsB,EAAE;EAChE,MAAM,eAAe,EAAE,SAAS,EAAE;EAClC,OAAO,kBAAkB,EAAE;EAC3B;;mBAEiB,0BAA0B,EAAE,SAAS,EAAE;EACxD,oBAAoB,0BAA0B,EAAE;EAChD,SAAS,aAAa,EAAE;EACxB,WAAW,sBAAsB,EAAE;EACnC,iBAAiB,WAAW,EAAE;EAC9B,gBAAgB,uBAAuB,EAAE,eAAe,EAAE;EAC1D,gCAAgC,iBAAiB,EAAE;EACnD,gBAAgB,eAAe,EAAE,gBAAgB,EAAE;AACrD;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kDAAkD;EAClD,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".site-header {\n  min-height: 84px;\n  padding: 18px 5%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  background: white;\n  border-bottom: 1px solid #e0e7e0;\n}\n.brand {\n  font-size: 19px;\n  font-weight: 700;\n  color: #20332e;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n.brand-icon {\n  background: #285c46;\n  color: white;\n  padding: 8px;\n  border-radius: 9px;\n  font-family: monospace;\n}\nnav {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  font-size: 14px;\n}\nnav .active {\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 8px;\n}\nmain {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 48px 32px;\n  min-height: calc(100vh - 145px);\n}\nfooter {\n  padding: 20px;\n  text-align: center;\n  color: #687b70;\n  font-size: 12px;\n}\n.eyebrow {\n  color: #43755b;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  font-size: 11px;\n  font-weight: 700;\n}\n.muted {\n  color: #64766c;\n  line-height: 1.65;\n}\n.panel {\n  background: white;\n  border: 1px solid #dfe7df;\n  border-radius: 14px;\n  padding: 28px;\n  margin-top: 30px;\n}\n.primary {\n  background: #285c46;\n  color: white;\n  border-color: #285c46;\n}\nbutton.primary:hover:not(:disabled) {\n  background: #1c4433;\n}\n.filters {\n  display: flex;\n  gap: 18px;\n  border-bottom: 1px solid #e4eae4;\n  padding-bottom: 24px;\n}\n.filters label {\n  width: 230px;\n}\n.problem-row {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  padding: 22px 2px;\n  border-bottom: 1px solid #e9eee9;\n  color: inherit;\n}\n.problem-row:hover {\n  background: #f8faf7;\n  text-decoration: none;\n}\n.problem-row > div {\n  flex: 1;\n}\n.problem-row h2 {\n  margin: 0 0 8px;\n}\n.problem-row p {\n  margin: 0;\n  font-size: 13px;\n}\n.badge {\n  display: inline-block;\n  background: #edf0ed;\n  color: #53645a;\n  padding: 5px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n.difficulty-1 {\n  color: #246342;\n  background: #e9f4ec;\n}\n.difficulty-2 {\n  color: #866014;\n  background: #fcf3db;\n}\n.difficulty-3 {\n  color: #a54843;\n  background: #fbeceb;\n}\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 18px;\n  margin-top: 24px;\n  font-size: 13px;\n}\n.auth-layout {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 80px;\n  align-items: center;\n  max-width: 1040px;\n  margin: 30px auto;\n}\n.auth-intro h1 {\n  font-size: clamp(36px, 5vw, 58px);\n  line-height: 1.13;\n}\n.auth-intro > p:last-child {\n  color: #64766c;\n  line-height: 1.8;\n  max-width: 370px;\n}\n.auth-card form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 26px;\n}\n.auth-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  font-size: 12px;\n  margin-top: 26px;\n}\n.error {\n  background: #fff0ed;\n  color: #a23228;\n  padding: 14px;\n  border-radius: 8px;\n  line-height: 1.5;\n}\n.success {\n  background: #edf7ef;\n  color: #23633d;\n  padding: 16px;\n  line-height: 1.6;\n}\n.page-heading {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-top: 16px;\n}\n.workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);\n  gap: 24px;\n}\n.workspace .panel {\n  margin-top: 0;\n}\n.prose {\n  white-space: pre-wrap;\n  line-height: 1.8;\n}\n.code-block {\n  background: #1c2521;\n  color: #e7ede9;\n  padding: 16px;\n  border-radius: 8px;\n  overflow-x: auto;\n  font-size: 13px;\n  line-height: 1.6;\n}\n.progress-summary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-top: 30px;\n}\n.progress-stat,\n.progress-section {\n  background: white;\n  border: 1px solid #dfe7df;\n  border-radius: 10px;\n  padding: 22px;\n}\n.progress-stat strong {\n  display: block;\n  color: #285c46;\n  font-size: 30px;\n}\n.progress-stat span,\n.progress-row span,\n.activity-list time {\n  color: #64766c;\n  font-size: 13px;\n}\n.progress-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-top: 24px;\n}\n.progress-section h2 { margin-top: 0; }\n.progress-row,\n.activity-list li {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid #e9eee9;\n}\n.activity-list { list-style: none; padding: 0; }\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 3px solid #d18b28;\n  outline-offset: 3px;\n}\n@media (max-width: 760px) {\n  .site-header { align-items: flex-start; flex-direction: column; }\n  nav { flex-wrap: wrap; gap: 14px; }\n  main { padding: 32px 18px; }\n  .workspace,\n  .auth-layout,\n  .progress-grid { grid-template-columns: 1fr; gap: 18px; }\n  .progress-summary { grid-template-columns: 1fr; }\n  .panel { padding: 20px; }\n  .filters { flex-direction: column; }\n  .filters label { width: auto; }\n  .progress-row { align-items: flex-start; flex-wrap: wrap; }\n  .progress-row span:last-child { margin-left: auto; }\n  .table-scroll { max-width: 100%; overflow-x: auto; }\n}\n.tags {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 24px 0;\n}\n.editor {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  overflow: hidden;\n}\n.editor-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 20px;\n}\n.editor-heading label {\n  font-size: 12px;\n}\n.code-label {\n  padding: 0 20px 10px;\n}\n.code-editor {\n  width: 100%;\n  flex: 1;\n  min-height: 400px;\n  resize: vertical;\n  background: #1d2c26;\n  color: #d9ecdf;\n  border: none;\n  padding: 24px;\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 14px;\n  line-height: 1.75;\n  tab-size: 4;\n}\n.code-editor::placeholder {\n  color: #a1b9ab;\n}\n.editor-footer {\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  justify-content: space-between;\n  font-size: 12px;\n}\n.editor .error {\n  margin: 12px;\n}\n.empty {\n  padding: 45px 20px;\n  text-align: center;\n  color: #64766c;\n}\n.table-scroll {\n  overflow-x: auto;\n}\ntable {\n  border-collapse: collapse;\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n}\nth {\n  color: #687b70;\n  font-size: 12px;\n  font-weight: 500;\n}\ntd,\nth {\n  padding: 18px 14px;\n  border-bottom: 1px solid #e5ebe5;\n}\n.result-meta {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n.result-meta button {\n  margin-left: auto;\n}\n.submitted-code {\n  background: #1d2c26;\n  color: #d9ecdf;\n}\n@media (max-width: 760px) {\n  main {\n    padding: 28px 18px;\n  }\n  .site-header {\n    flex-wrap: wrap;\n    padding: 16px 18px;\n  }\n  nav {\n    gap: 16px;\n  }\n  .auth-layout,\n  .workspace {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n  .auth-layout {\n    margin: 0;\n  }\n  .auth-intro h1 {\n    font-size: 36px;\n  }\n  .panel {\n    padding: 20px;\n  }\n  .editor {\n    padding: 0;\n  }\n  .filters {\n    flex-wrap: wrap;\n  }\n  .filters label {\n    width: 100%;\n  }\n  .problem-row {\n    gap: 12px;\n  }\n  .page-heading {\n    flex-wrap: wrap;\n    gap: 0 16px;\n  }\n  .editor-footer {\n    flex-wrap: wrap;\n  }\n  .result-meta {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
